module.exports = __webpack_public_path__ + "static/media/image_71.6eea66ac.png";